<template>
  <a-spin :spinning="loading">
    <a-layout>
      <a-layout-header
        style="height: auto; padding: 0px; background: rgba(0, 0,0,0.05);padding-top: 5px;padding-left: 5px;padding-bottom: 5px;">
        <a-form-model layout="inline">
          <a-form-model-item>
            <a-button shape="circle" icon="plus" @click="agregarComponente"/>
          </a-form-model-item>
          <a-form-model-item label="Alto">
            <a-select v-model="setup.chartHeight" placeholder="please select your zone">
              <a-select-option value="200">200</a-select-option>
              <a-select-option value="300">300</a-select-option>
              <a-select-option value="400">400</a-select-option>
              <a-select-option value="500">500</a-select-option>
              <a-select-option value="600">600</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Ancho">
            <a-select v-model="setup.chartWidth" placeholder="please select your zone">
              <a-select-option value="200">200</a-select-option>
              <a-select-option value="300">300</a-select-option>
              <a-select-option value="400">400</a-select-option>
              <a-select-option value="500">500</a-select-option>
              <a-select-option value="600">600</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Diseños guardados">
            <form-model-dropdown style="min-width: 250px;"
                                 endpoint="analytics_presets"
                                 v-model="presetId"
                                 :cache="false"
                                 ref="analyticsPresetsDropdown"
                                 :selectedObj.sync="presetSelected">
            </form-model-dropdown>
          </a-form-model-item>
          <a-form-model-item>
            <a-button shape="circle" icon="save" @click="guardarPreset" v-if="$isEmpty(presetId) || canEditDelete"/>
            <a-button shape="circle" icon="copy" @click="saveAsPreset" v-if="presetId"/>
            <a-button shape="circle" icon="edit" @click="editPreset" v-if="canEditDelete"/>
            <a-button shape="circle" icon="delete" @click="deletePreset" v-if="canEditDelete"/>
          </a-form-model-item>
        </a-form-model>
      </a-layout-header>
      <a-layout-content style="background: white;">
        <div id="workArea" :gutter="[16,16]">
          <analytics-chart-component v-for="component in setup.componentes"
                                     :options.sync="component.options"
                                     :height="setup.chartHeight"
                                     :width="setup.chartWidth"
                                     :idx="component.idx"
                                     :key="component.idx"
                                     v-on:delete="deleteIndex"></analytics-chart-component>
        </div>
      </a-layout-content>
      <a-modal v-model="savePresetVisible" title="Guardar Diseño" @ok="confirmaPresetCrud">
        <a-spin :spinning="loading">
          <a-form-model :model="presetInfo" ref="presetForm">
            <a-form-model-item label="Nombre del diseño" :rules="[{ required: true, message: 'Valor requerido' }]">
              <a-input v-model="presetInfo.nombre"></a-input>
            </a-form-model-item>
            <a-form-model-item label="Publico">
              <a-switch v-model="presetInfo.publico"/>
            </a-form-model-item>
          </a-form-model>
        </a-spin>
      </a-modal>
    </a-layout>
  </a-spin>
</template>
<script>
  import Sortable from 'sortablejs'
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        setup: {
          componentes: [],
          chartHeight: 300,
          chartWidth: 500
        },
        presetId: null,
        presetSelected: null,
        savePresetVisible: false,
        presetInfo: {
          action: 'create', // edit
          publico: false,
          nombre: ''
        },
        loading: false
      }
    },
    mounted () {
      let el = document.getElementById('workArea')
      this.sortable = Sortable.create(el, {
        animation: 150,
        ghostClass: 'blue-background-class'
      })
      this.httpClient = new HttpUtil('analytics_presets')
    },
    methods: {
      agregarComponente () {
        this.setup.componentes.push({
          idx: parseInt(Math.random() * 1000000).toString(),
          options: {
            reportParams: {}
          }
        })
      },
      deleteIndex (idx) {
        let index = false
        for (let i = 0; i < this.setup.componentes.length; i++) {
          const componente = this.setup.componentes[i]
          if (componente.idx === idx) {
            index = i
            break
          }
        }
        if (index !== false) {
          this.setup.componentes.splice(index, 1)
        }
      },
      guardarPreset () {
        if (JsUtils.isEmpty(this.presetId)) {
          this.modalPresetCrud({
            action: 'create',
            publico: false,
            nombre: ''
          })
        } else {
          this.loading = true
          this.httpClient.update({
            name: this.presetSelected.name,
            public: this.presetSelected.public,
            setup: this.getSetup(),
            id: this.presetId
          }, this.manejaOk, this.manejaError)
        }
      },
      saveAsPreset () {
        this.modalPresetCrud({
          action: 'create',
          publico: false,
          nombre: this.presetSelected.name
        })
      },
      editPreset () {
        this.modalPresetCrud({
          action: 'edit',
          publico: this.presetSelected.public,
          nombre: this.presetSelected.name
        })
      },
      modalPresetCrud (presetInfo) {
        this.presetInfo = presetInfo
        this.savePresetVisible = true
      },
      deletePreset () {
        if (!JsUtils.isEmpty(this.presetSelected)) {
          this.loading = true
          this.httpClient.delete(this.presetSelected.id, this.manejaEliminaOk, this.manejaError)
        }
      },
      confirmaPresetCrud () {
        this.$refs.presetForm && this.$refs.presetForm.validate(valid => {
          if (valid) {
            this.loading = true
            if (this.presetInfo.action === 'create') {
              this.httpClient.create({
                name: this.presetInfo.nombre,
                public: this.presetInfo.publico,
                setup: this.getSetup()
              }, this.manejaOk, this.manejaError)
            } else {
              this.httpClient.update({
                name: this.presetInfo.nombre,
                public: this.presetInfo.publico,
                setup: this.getSetup(),
                id: this.presetId
              }, this.manejaOk, this.manejaError)
            }
          }
        })
      },
      manejaEliminaOk () {
        Mensajes.success('Eliminado correctamente')
        this.$refs.analyticsPresetsDropdown && this.$refs.analyticsPresetsDropdown.loadOptions()
        this.loading = false
        this.presetId = null
      },
      manejaOk (response) {
        Mensajes.success('Guardado correctamente')
        this.savePresetVisible = false
        this.$refs.analyticsPresetsDropdown && this.$refs.analyticsPresetsDropdown.loadOptions()
        this.loading = false
        this.presetId = response.data.id.toString()
      },
      manejaError (error) {
        Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible guardar el diseño'))
        this.loading = false
      },
      getSetup () {
        return {
          componentes: this.getOrderedCompoents(),
          chartHeight: this.setup.chartHeight,
          chartWidth: this.setup.chartWidth
        }
      },
      getOrderedCompoents () {
        let orden = this.sortable.toArray()
        let components = []
        orden.map(id => {
          for (let i = 0; i < this.setup.componentes.length; i++) {
            const componente = this.setup.componentes[i]
            if (componente.idx === id) {
              components.push(componente)
              break
            }
          }
        })

        return components
      }
    },
    watch: {
      presetSelected () {
        if (JsUtils.isEmpty(this.presetSelected)) {
          this.setup = {
            componentes: [],
            chartHeight: 300,
            chartWidth: 500
          }
        } else {
          this.setup = JSON.parse(this.presetSelected.preset_setup)
        }
      }
    },
    computed: {
      canEditDelete () {
        if (JsUtils.isEmpty(this.presetSelected)) {
          return false
        } else {
          return this.presetSelected.created_by === this.$store.state.userInfo.name
        }
      }
    }
  }
</script>
<style>
  .blue-background-class {
    background: rgba(0, 0, 255, 0.1);
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Analytics/Analytics.vue